import showToast from '../components/ToastComponent';
import instance from '../config/axios';
import { Endpoints } from './endPoints';

export const callProducts = async () => {
  try {
    const response = await instance({
      url: Endpoints.GET_ACCESSORIES,
      method: 'GET',
    });
    const accessories = response?.data || [];
    return accessories;
  } catch (error) {
    showToast({
      message: 'Failed to get Products',
      type: 'error',
    });
    return [];
  }
};
